import { render } from "./ClientReportesUtilidadAproximada.vue?vue&type=template&id=8711effa&scoped=true"
import script from "./ClientReportesUtilidadAproximada.vue?vue&type=script&lang=js"
export * from "./ClientReportesUtilidadAproximada.vue?vue&type=script&lang=js"

import "./ClientReportesUtilidadAproximada.vue?vue&type=style&index=0&id=8711effa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8711effa"]])

export default __exports__